const MONTHS = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const integer = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

export const formatMoney = (value) => (value === null || value === undefined ? '' : currency.format(value));

export const formatKm = (value) => (value ? `${integer.format(value)} km` : '');

// "12 de setembro de 2026"
export const formatLongDate = (date) =>
  date ? `${date.getUTCDate()} de ${MONTHS[date.getUTCMonth()]} de ${date.getUTCFullYear()}` : 'Data não informada';

// "12 set"
export const formatShortDate = (date) =>
  date ? `${String(date.getUTCDate()).padStart(2, '0')} ${MONTHS[date.getUTCMonth()].slice(0, 3)}` : '';

// "Setembro de 2026" (cabecalho dos grupos da linha do tempo)
export const formatMonthYear = (date) => {
  if (!date) return 'Sem data';
  const month = MONTHS[date.getUTCMonth()];
  return `${month.charAt(0).toUpperCase()}${month.slice(1)} de ${date.getUTCFullYear()}`;
};

export const monthKey = (date) => (date ? `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}` : 'sem-data');

// Placa no padrao visual: ABC-1234 ou ABC1D23
export const formatPlate = (plate) => {
  const value = String(plate || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return /^[A-Z]{3}\d{4}$/.test(value) ? `${value.slice(0, 3)}-${value.slice(3)}` : value;
};

export const formatPhone = (digits) => {
  const value = String(digits || '').replace(/\D/g, '');
  if (value.length === 11) return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (value.length === 10) return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return value;
};

export const formatCnpj = (digits) => {
  const value = String(digits || '').replace(/\D/g, '');
  if (value.length === 14) return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  if (value.length === 11) return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return value;
};

export const firstName = (name) => String(name || '').trim().split(/\s+/)[0] || '';

export const plural = (count, singular, pluralForm) => (count === 1 ? singular : pluralForm);

// A API nao informa o tipo do atendimento; o titulo usa o numero que a empresa enviou.
export const recordTitle = (record) =>
  record.source === 'os' ? `Ordem de serviço nº ${record.code}` : `Atendimento nº ${record.code}`;

// "12 set 2026"
export const formatDayMonthYear = (date) =>
  date ? `${date.getUTCDate()} ${MONTHS[date.getUTCMonth()].slice(0, 3)} ${date.getUTCFullYear()}` : 'data não informada';
